// Sélecteur de statut MANUEL post-envoi du devis OMV (Signé → En cours → À facturer →
// Facturé → Payé). Couche d'affichage : POST /api/metier/devis/{id}/statut-omv pose
// devis.statut_omv (l'enum technique reste inchangé) + sync dossier côté backend.
// Auto (Validé/Envoyé) reste géré par les actions Valider/Envoyer.
import { useState } from "react";
import { toast } from "sonner";
import { getCurrentTenantSlug } from "../../lib/utils";
import { DEVIS_STATUTS_MANUELS, DEVIS_STATUT_DEFAULTS } from "../../utils/devisStatut";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function DevisStatutOmvSelect({ devis, tenantId, statutsList, onChanged }) {
  const [saving, setSaving] = useState(false);
  const id = devis?.id || devis?._id;
  const current = devis?.statut_omv || "";
  const labelFor = (key) =>
    (statutsList || []).find((i) => (i.id || i.value) === key)?.label
    || DEVIS_STATUT_DEFAULTS.find((i) => i.id === key)?.label
    || key;

  const post = async (val) => {
    if (!id) return;
    setSaving(true);
    try {
      const token = localStorage.getItem("session_token");
      const res = await fetch(`${API}/api/metier/devis/${encodeURIComponent(id)}/statut-omv`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-Tenant-ID": tenantId || getCurrentTenantSlug(),
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ statut: val }),
      });
      if (res.ok) {
        toast.success("Statut devis mis à jour");
        onChanged?.();
      } else {
        const e = await res.json().catch(() => ({}));
        toast.error(typeof e.detail === "string" ? e.detail : "Erreur de mise à jour");
      }
    } catch (e) {
      toast.error("Erreur réseau");
    } finally {
      setSaving(false);
    }
  };

  return (
    <select
      value={current}
      disabled={saving}
      onChange={(e) => post(e.target.value)}
      data-testid="devis-statut-omv-select"
      title="Statut manuel du devis (post-envoi)"
      className="h-8 rounded px-2 text-xs"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text)", colorScheme: "light dark" }}
    >
      <option value="">— Auto (Validé / Envoyé) —</option>
      {DEVIS_STATUTS_MANUELS.map((key) => (
        <option key={key} value={key}>{labelFor(key)}</option>
      ))}
    </select>
  );
}
